import React, { Component, Fragment } from 'react';
import { LabeledInput } from '../../../../../shared/labeled-input/LabeledInput';
import { connect } from 'react-redux';
import { createUser } from './redux/actions';
import { fetchTeams } from '../../teams/redux/teams-list/actions';
import { getTeams } from '../../teams/redux/teams-list/selectors';
import TransparentButton from '../../../../../shared/button/transparent-button/TransparentButton';
import { BlueContainedButton } from '../../../../../shared/button/blue-contained-button/BlueContainedButton';

import * as _ from 'lodash';
import './CreateUser.scss';
import { TeamMultiSelect } from '../../../../../shared/team-multi-select/TeamMultiSelect';
import { getCreatedUser } from './redux/selectors';

class CreateUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: null,
            lastName: null,
            email: null,
            belongsInTeams: [],
            password: null,
            active: true
        };
    }

    componentDidMount() {
        this.props.fetchTeams();
    }

    handleFirstNameChange = firstName =>
        this.setState({
            ...this.state,
            firstName
        });

    handleLastNameChange = lastName =>
        this.setState({
            ...this.state,
            lastName
        });

    handleEmailChange = email =>
        this.setState({
            ...this.state,
            email
        });

    handlePasswordChange = password =>
        this.setState({
            ...this.state,
            password
        });

    handleBelongsInTeamsChange = teams =>
        this.setState({
            ...this.state,
            belongsInTeams: teams.map(team => team.id)
        });

    handleCreateUser = () => {
        const { createUser, createdUser, closeModal } = this.props;
        const {
            firstName,
            lastName,
            email,
            belongsInTeams,
            active,
            password
        } = this.state;

        _.isFunction(createUser) &&
            createUser(
                firstName,
                lastName,
                email,
                belongsInTeams,
                password,
                active
            );

        if (createdUser) {
            _.isFunction(closeModal) && closeModal();
        }
    };

    isCreateUserButtonDisabled = () =>
        !(
            this.state &&
            this.state.firstName &&
            this.state.lastName &&
            this.state.email &&
            this.state.password
        );

    render() {
        const { teams, closeModal } = this.props;
        return (
            <Fragment>
                <form
                    className={'create-user-form'}
                    onSubmit={this.handleCreateUser}
                >
                    <LabeledInput
                        label={'First Name'}
                        onChange={this.handleFirstNameChange}
                        className={'row form-row'}
                        value={this.state.firstName}
                        required={true}
                    />
                    <LabeledInput
                        label={'Last Name'}
                        onChange={this.handleLastNameChange}
                        className={'row form-row'}
                        value={this.state.lastName}
                        required={true}
                    />
                    <LabeledInput
                        label={'Email'}
                        onChange={this.handleEmailChange}
                        className={'row form-row'}
                        value={this.state.email}
                        required={true}
                        type={'email'}
                    />
                    <LabeledInput
                        label={'Password'}
                        onChange={this.handlePasswordChange}
                        className={'row form-row'}
                        value={this.state.password}
                        required={true}
                        type={'password'}
                    />

                    {/* todo: Select is breaking when you remove a selected item */}
                    <TeamMultiSelect
                        label={'Teams'}
                        className={'row form-row'}
                        onChange={this.handleBelongsInTeamsChange}
                        teams={teams}
                    />
                    <div className={'actions'}>
                        <TransparentButton onClick={closeModal}>
                            Cancel
                        </TransparentButton>
                        <BlueContainedButton
                            text={'Create User'}
                            disabled={this.isCreateUserButtonDisabled()}
                            onClick={this.handleCreateUser}
                        />
                    </div>
                </form>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    teams: getTeams(state),
    createdUser: getCreatedUser(state)
});

const mapDispatchToProps = dispatch => ({
    fetchTeams: () => dispatch(fetchTeams()),
    createUser: (
        firstName,
        lastName,
        email,
        belongsInTeams,
        password,
        active
    ) =>
        dispatch(
            createUser({
                firstName,
                lastName,
                email,
                belongsInTeams,
                password,
                active
            })
        )
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
